export const ROOT_BREADCRUMB = {
  name: 'Главная',
  href: '/',
}

export const PROJECT_BREADCRUMB = [
  ROOT_BREADCRUMB,
  {
    name: 'Проекты',
    href: '/projects',
  },
]

export const TEMPLATES_BREADCRUMB = {
  name: 'Шаблоны',
  href: '/templates',
}

export const PROJECT_PORTFOLIO_PANEL_BREADCRUMB = [
  ROOT_BREADCRUMB,
  {
    name: 'Панель проектного портфеля',
    href: '',
  },
]
